if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      // Find or create the live region used to announce ATC outcomes.
      getLiveRegion() {
        let region = document.getElementById("ProductForm-LiveRegion");
        if (!region) {
          region = document.createElement("p");
          region.id = "ProductForm-LiveRegion";
          region.className = "visually-hidden";
          region.setAttribute("role", "status");
          region.setAttribute("aria-live", "polite");
          document.body.appendChild(region);
        }
        return region;
      }

      announce(message) {
        const region = this.getLiveRegion();
        // Force the screen reader to re-read by clearing then setting.
        region.textContent = "";
        // Use a microtask delay so AT picks up the change.
        setTimeout(() => { region.textContent = message; }, 50);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.setAttribute("aria-busy", "true");
        this.submitButton.classList.add("loading");
        this.announce("Adding to cart");

        const config = {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        };

        const formData = new FormData(this.form);
        formData.append("sections", ["cart-bubble", "cart-drawer"]);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Shopify error response (status code present means failure)
              this.handleErrorMessage(response.description);
              this.announce(
                response.description ||
                "Could not add item to cart. Please try again."
              );
              this.error = true;
              return;
            }

            // Update cart bubble counters if they exist.
            const bubbleSticky = document.getElementById("cart-details--sticky");
            if (bubbleSticky && response.sections && response.sections["cart-bubble"]) {
              const match = response.sections["cart-bubble"].match(/\d+/);
              if (match) bubbleSticky.innerHTML = match[0];
            }

            const bubbleRelative = document.getElementById("cart-details--relative");
            if (bubbleRelative && response.sections && response.sections["cart-bubble"]) {
              const match = response.sections["cart-bubble"].match(/\d+/);
              if (match) bubbleRelative.innerHTML = match[0];
            }

            // Update cart drawers if they exist (don't crash if missing).
            ["dialog-cart-1", "dialog-cart-2"].forEach((dialogId) => {
              const dialog = document.getElementById(dialogId);
              if (dialog && response.sections && response.sections["cart-drawer"]) {
                const body = dialog.querySelector(".dialog__content__body");
                if (body) {
                  body.innerHTML = response.sections["cart-drawer"];
                }
                if (dialog.parentNode) {
                  dialog.parentNode.open = true;
                }
              }
            });

            // Announce success to screen readers.
            const productTitle = this.form
              .closest("[data-product-title]")?.dataset.productTitle ||
              document.querySelector("h1")?.textContent.trim() ||
              "Item";
            this.announce(`${productTitle} added to cart`);

            this.error = false;
          })
          .catch((error) => {
            console.error(error);
            this.announce("Could not add item to cart. Please try again.");
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.removeAttribute("aria-busy");
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }
          });
      }

      handleErrorMessage(errorText = false) {
        if (this.hideErrors) return;

        this.errorMessage =
          this.errorMessage || this.querySelector(".message-error");
        if (!this.errorMessage) return;

        this.errorMessage.classList.toggle("hidden", !errorText);

        const svg = this.errorMessage.querySelector("svg");
        const icon = svg ? svg.outerHTML : "";

        this.errorMessage.innerHTML = errorText
          ? icon + `<span>${errorText}</span>`
          : icon;
      }
    }
  );
}